import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "accounts",
    class: "flex items-center mb-4"
};
const _hoisted_2 = {
    key: 0,
    class: "admin-table"
};
const _hoisted_3 = { class: "colored-row" };
const _hoisted_4 = { class: "w-16" };
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = { class: "font-medium" };
const _hoisted_7 = ["id"];
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "text-center" };
const _hoisted_10 = { class: "font-medium" };
const _hoisted_11 = { class: "sr-only" };
const _hoisted_12 = { class: "my-loading" };
const _hoisted_13 = { class: "no-results panel p-10 mt-4" };
const _hoisted_14 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Accounts", -1)),
            _createElementVNode("nav", null, [
                (_ctx.index.isLoaded() && _ctx.permissions.isAdmin())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.account.create' },
                        class: "btn"
                    }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" Create Account ", -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.index.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Name / Portal"),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-center"
                                        }, "Status"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (account) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                            _createElementVNode("td", _hoisted_4, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": account.slug
                                                }, [...(_cache[2] || (_cache[2] = [
                                                        _createElementVNode("title", null, "Account", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_5))
                                            ]),
                                            _createElementVNode("td", _hoisted_6, [
                                                _createElementVNode("span", {
                                                    class: "block",
                                                    id: account.slug
                                                }, _toDisplayString(account.name), 9, _hoisted_7),
                                                _createElementVNode("a", {
                                                    href: account.endpoint,
                                                    target: "_blank"
                                                }, _toDisplayString(account.endpoint), 9, _hoisted_8)
                                            ]),
                                            _createElementVNode("td", _hoisted_9, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-box", {
                                                            'status-active': account.active === true,
                                                            'status-cancelled': account.active === false,
                                                        }])
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(account.active ? 'Active' : 'Inactive'), 1),
                                                    _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                                                        _createElementVNode("span"),
                                                        _createElementVNode("span")
                                                    ], -1))
                                                ], 2)
                                            ]),
                                            _cache[5] || (_cache[5] = _createElementVNode("td", null, "   ", -1)),
                                            _cache[6] || (_cache[6] = _createElementVNode("td", null, "   ", -1)),
                                            _createElementVNode("td", _hoisted_10, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'admin.account.manage', params: { slug: account.slug } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _cache[4] || (_cache[4] = _createTextVNode(" Manage Account", -1)),
                                                        _createElementVNode("span", _hoisted_11, ", " + _toDisplayString(account.name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"])
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Loading, { message: "Loading Accounts" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#accounts",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            role: "img",
                            focusable: "false",
                            "aria-label": "No Accounts Available"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            })
                        ])
                    ], -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Accounts Available", -1)),
                    _createElementVNode("p", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createTextVNode(" We could not find any accounts, ", -1)),
                        _createVNode(_component_router_link, { to: { name: 'admin.account.create' } }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("create one", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[11] || (_cache[11] = _createTextVNode(". ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ], 64));
}
